import React from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'

import { useAuth } from '../AuthProvider/AuthProvider'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'
import { useReorder } from '../Reorder/ReorderProvider/ReorderProvider'
import { ReorderCard } from '../Reorder/ReorderCard/ReorderCard'
import Error from '../Error/Error'

import ReorderIcon from '../../assets/reorder.svg'
import './ReorderBanner.css'
import {useReorderQuery} from '../ReorderQuery/ReorderQuery'

export const ReorderBanner = () => {
  const { authenticated } = useAuth()
  const { getRestaurantPath } = useRestaurant()
  const { data } = useReorderQuery()

  const { reorderMutation: [, { error }] } = useReorder()

  if (!authenticated || !data || data.paginatedOrders.orders.length === 0) {
    return null
  }

  const ordersLink = getRestaurantPath('orders')

  return (
    <div styleName='container'>
      <div styleName='wrap'>
        <div styleName='header'>
          <div styleName='orderAgain'>
            <ReorderIcon />
            <h2 styleName='title'>Order Again</h2>
          </div>
          <Link
            to={ordersLink}
            styleName={cx('viewMore', {
              desktop: data.paginatedOrders.totalSize > 2,
              mobile: data.paginatedOrders.totalSize > 1
            })}
          >
          View More
          </Link>
        </div>
        {Boolean(error) && <Error error={error} />}
        <ul styleName='orderList'>
          {data.paginatedOrders.orders.map((order, idx) => (
            <ReorderCard
              key={order.guid}
              orderGuid={order.guid}
              items={order.selections}
              price={order.totalV2}
              date={order.estimatedFulfillmentDate}
              hideOnMobile={idx > 0}
            />
          ))}
        </ul>
      </div>
    </div>
  )
}
